import React, { useState, useEffect } from 'react'
import { css, StyleSheet } from 'aphrodite'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AdministrativeQuestions } from './AdministrativeQuestions'
import { MailConfirmation } from './MailConfirmation'
import { WorkStatus } from './WorkStatus'
import { Waiting } from './Waiting'
import LayoutSidePanel from '../../../components/Layout/LayoutSidePanel'
import WidgetMakerHeader from '../../../components/Widget/WidgetMakerHeader'
import UIProgressCircle from '../../../components/UI/UIProgressCircle'
import UIMakerMenuLink from './../../../components/UI/UIMakerMenuLink'
import { MEDIA_MIN_SM } from '../../../lib/breakpoints'
import IconPreviousPage from '../../../components/Icon/IconPreviousPage'
import { useNavigate } from 'react-router-dom'

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  containerSidePanel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  makerLink: {
    display: 'none',
    [MEDIA_MIN_SM]: {
      display: 'block',
    },
  },
  progressText: {
    fontSize: 16,
    fontWeight: 700,
  },
  flex: {
    flexDirection: 'column',
  },
  buttonLable: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer',
  },
  return: {
    marginBottom: '20px',
    padding: '7.5px 16px',
  },
})

const RegisterSteps = () => {
  const { t } = useTranslation('translation')
  let navigate = useNavigate()

  const location = useLocation()
  const [activetab, setActivetab] = useState('')
  const [registerFullCompleted, setRegisterFullCompleted] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const registerStatus = localStorage.getItem('registerStatus')
    if (registerStatus === 'fullCompleted') {
      setRegisterFullCompleted(true)
      setLoading(false)
    } else {
      setLoading(false)
    }
  }, [])

  const path = registerFullCompleted
    ? 'waiting'
    : location?.pathname?.substring(location?.pathname?.lastIndexOf('/') + 1)

  useEffect(() => {
    if (path) {
      handleActiveTab(path)
    }
  }, [location])

  const handleActiveTab = (path) => {
    setActivetab(path)
  }

  const calculateProgression = (currentTab) => {
    const pathName = currentTab === 'reconnect' ? 'confirmation' : currentTab
    return Math.trunc(
      (ListSideMenu.findIndex((menu) => menu.route === pathName) * 100) /
        (ListSideMenu.length - 1)
    )
  }

  const ListSideMenu = [
    {
      route: 'administrative-questions',
      label: `${t('pages.registerMaker.steps.administrativeQuestions')}`,
    },
    {
      route: 'confirmation',
      label: `${t('pages.registerMaker.steps.confirmation')}`,
    },
    {
      route: 'documents',
      label: `${t('pages.registerMaker.steps.yourDocuments')}`,
    },
    {
      route: 'waiting',
      label: `${t('pages.registerMaker.steps.patience')}`,
    },
  ]

  return (
    <>
      {loading ? (
        <div>{t('pages.viewerAccount.demand.loading')}</div>
      ) : (
        <div className={css(styles.container)}>
          <WidgetMakerHeader
            handleBecomeMakerClick={() => {
              console.log('handleBecomeMakerClick')
            }}
            handleGlobeClick={() => {
              console.log('handleGlobeClick')
            }}
          />
          <LayoutSidePanel
            menu={
              <>
                <div className={css(styles.containerSidePanel)}>
                  <div
                    onClick={() => {
                      navigate('/')
                    }}
                    className={css(styles.buttonLable)}
                  >
                    <IconPreviousPage color="black" />
                    <p>{t('common.button.home')}</p>
                  </div>
                  <b className={css(styles.progressText)}>
                    {t('common.progress')}
                  </b>
                  <br />
                  <UIProgressCircle percent={calculateProgression(path)} />
                </div>
                <br />
                {ListSideMenu.map((menu, key) => {
                  return (
                    <UIMakerMenuLink
                      key={key}
                      isActive={activetab === menu.route}
                      route={`${menu.route}`}
                      text={menu.label}
                      dynamicStyle={styles.makerLink}
                    />
                  )
                })}
              </>
            }
          >
            <div>
              <Routes>
                {registerFullCompleted ? (
                  <Route path="/" element={<Navigate to="waiting" />} />
                ) : (
                  <Route
                    path="/"
                    element={<Navigate to="administrative-questions" />}
                  />
                )}

                <Route
                  path="administrative-questions"
                  element={<AdministrativeQuestions />}
                />
                <Route path="reconnect" element={<MailConfirmation />} />
                <Route path="confirmation" element={<MailConfirmation />} />
                <Route path="documents" element={<WorkStatus />} />
                <Route path="waiting" element={<Waiting />} />
              </Routes>
            </div>
          </LayoutSidePanel>
        </div>
      )}
    </>
  )
}

export default RegisterSteps
